import { STATICS } from 'statics'
import { Card } from '../card'
import './style.scss'

export function CardButton({ className, icon, onClick, children, isLoading = false }) {
  function handleClick() {
    if (isLoading) return

    onClick()
  }

  function renderLoading() {
    if (!isLoading) return null

    return <div className='loading-container' />
  }

  return (
    <Card className={`card-button-component ${className}`} thin onClick={handleClick}>
      {renderLoading()}
      <div className='icon'>{icon}</div>
      {children}
      <div className='arrow-icon'>
        <STATICS.ARROW_CARD_BUTTON />
      </div>
    </Card>
  )
}
